// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__I3T8p","submit":"CustomButton_submit__84YtP"};